var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @bolshchikov please remove after buttons integration
import colors from '../colors';
var squaredBaseStyles = {
    borderRadius: '8px',
    boxShadow: 'none',
    textTransform: 'none',
    minWidth: 'auto',
    padding: '8px 16px',
    border: "1px solid",
    boxSizing: 'border-box',
    fontWeight: '700',
    fontSize: 12,
    lineHeight: '15px',
};
var primaryBaseStyles = {
    color: colors.white,
    backgroundColor: colors.blue[500],
    borderColor: colors.blue[500],
    '&:hover': {
        boxShadow: 'none',
        color: colors.white,
        background: colors.blue[300],
        borderColor: colors.blue[300],
    },
    '&:active, &.Mui-focused': {
        color: colors.white,
        background: colors.blue[600],
        borderColor: colors.blue[600],
    },
    '&:disabled': {
        color: colors.white,
        background: colors.grey[500],
        borderColor: colors.grey[500],
    },
};
var secondaryBaseStyles = {
    color: colors.grey[900],
    backgroundColor: colors.white,
    borderColor: colors.grey[300],
    fontWeight: 500,
    '&:hover': {
        color: colors.grey[900],
        backgroundColor: colors.white,
        borderColor: colors.blue[500],
    },
    '&:active, &.Mui-focused': {
        color: colors.grey[900],
        backgroundColor: colors.grey[100],
        borderColor: colors.grey[300],
    },
    '&:disabled': {
        color: colors.grey[500],
        borderColor: colors.grey[300],
    },
};
var errorBaseStyles = {
    color: colors.white,
    backgroundColor: colors.blush[500],
    borderColor: colors.blush[500],
    '&:hover': {
        color: colors.white,
        background: colors.blush[300],
        borderColor: colors.blush[300],
    },
    '&:active, &.Mui-focused': {
        color: colors.white,
        background: colors.blush[600],
        borderColor: colors.blush[600],
    },
    '&:disabled': {
        color: colors.blush[300],
        background: colors.grey[500],
        borderColor: colors.grey[500],
    },
};
var roundedBaseStyles = {
    borderRadius: '40px',
    border: "1px solid",
    boxShadow: 'none',
    '&:hover': {
        boxShadow: 'none',
    },
    textTransform: 'none',
    minWidth: 'auto',
    padding: '8px 16px',
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '15px',
    backgroundBlendMode: 'overlay, normal',
};
export var temporarySweepVariants = [
    {
        props: {
            variant: 'rounded',
            color: 'primary',
        },
        style: __assign(__assign({}, roundedBaseStyles), primaryBaseStyles),
    },
    {
        props: {
            variant: 'rounded',
            color: 'secondary',
        },
        style: __assign(__assign({}, roundedBaseStyles), secondaryBaseStyles),
    },
    {
        props: {
            variant: 'rounded',
            color: 'error',
        },
        style: __assign(__assign({}, roundedBaseStyles), errorBaseStyles),
    },
    {
        props: {
            variant: 'squared',
            color: 'primary',
        },
        style: __assign(__assign({}, squaredBaseStyles), primaryBaseStyles),
    },
    {
        props: {
            variant: 'squared',
            color: 'secondary',
        },
        style: __assign(__assign({}, squaredBaseStyles), secondaryBaseStyles),
    },
    {
        props: {
            variant: 'squared',
            color: 'error',
        },
        style: __assign(__assign({}, squaredBaseStyles), errorBaseStyles),
    },
];
